import { Portal } from 'react-portal'
import { Link } from 'react-router-dom'

import type { ReactElement } from 'react'

const Unauthorized = (): ReactElement => {
  return (
    <Portal>
      <div className="error-boundary-container">
        <div className="error-boundary-fallback">
          <p className="sorry">Not authorized :(</p>
          <p className="message">You might not have permission to view this page.</p>
          <p className="message">
            Please contact an administrator or return to <Link to="/">home</Link>
          </p>
        </div>
      </div>
    </Portal>
  )
}

export default Unauthorized
